import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceResponse } from 'src/app/@shared/interfaces/service-response.interface';
import { Rating } from '../interfaces/route-planning/rating.interface';
import { HttpHandler } from '@angular/common/http';
import { HttpClientService } from 'src/app/@shared/services/http-client/http-client.service';
import { environment } from 'src/environments/environment';
import { LanguageService } from 'src/app/@shared/services/language/language.service';

@Injectable({
  providedIn: 'root',
})
export class RatingRepository {
  constructor(
    private readonly httpClientService: HttpClientService,
    httpHandler: HttpHandler,
    languageService: LanguageService
  ) {
    this.httpClientService = new HttpClientService(httpHandler, languageService);
    this.httpClientService.apiUrl = environment.rating_service_url;
  }

  addRating(body: {
    sessionId: string;
    entityId: string;
    rating: number;
    type: number;
  }): Observable<ServiceResponse<Rating>> {
    return this.httpClientService.mot_post('RoutePlanning/AddRating', body);
  }
}
